module.exports = __webpack_public_path__ + "static/media/sidebar-7.b8c42359.jpg";